import useTranslation from '~/client/hooks/i18n/useTranslation';
import useAgentData from '~/client/hooks/useAgentData';
import sendEventToUmami from '~/shared/trackEvent/sendEventToUmami';
import useSelectedFiltersStore from '../../../GameList/store/useSelectedFiltersStore';
import getSelectTitle from '../utils/getSelectTitle';

type Props = { type: FilterSection };

const useSelectFilter = ({ type }: Props) => {
  const { categories, providers, setCategories, setProviders } =
    useSelectedFiltersStore();

  const selected = type === 'categories' ? categories : providers;
  const { isMobile } = useAgentData();
  const selectText = useTranslation(getSelectTitle(type));
  const isCategories = type === 'categories';
  const allCategories = useTranslation('general.all_categories');
  const allProviders = useTranslation('general.all_providers');
  const allText = isCategories ? allCategories : allProviders;
  const label = selected?.length || allText;
  const left = type === 'providers';

  const handleChange = (newSelected: string[]) => {
    switch (type) {
      case 'categories':
        setCategories(newSelected);
        sendEventToUmami(
          {
            handle: newSelected,
          },
          'changeCategoryFilter',
        );
        break;
      case 'providers':
        setProviders(newSelected);
        sendEventToUmami(
          {
            handle: newSelected,
          },
          'changeProviderFilter',
        );
        break;
      default:
        break;
    }
  };

  const getGridArea = () => {
    switch (type) {
      case 'categories':
        return '[grid-area:categories]';
      case 'providers':
        return '[grid-area:providers]';
      default:
        return '[grid-area:sort]';
    }
  };

  return {
    isFullWidth: isMobile,
    left,
    label,
    selectText,
    selected,
    handleChange,
    gridArea: getGridArea(),
  };
};

export default useSelectFilter;
